export default __webpack_public_path__ + "static/video-wiz-1-265dc34379241eb2943a8191e1f25123.mp4";